import { IEventsRequestModel, IPatchStatusModel } from '../../../../models/index';
import {
  clearEvent,
  createEventFail,
  createEventStarted,
  createEventSuccess,
  updateEventFail,
  updateEventSuccess
} from '../../../reducer/events/EventReducer';
import { createEvent, patchEventStatusType, updateEvents } from '../../actionType/events/EventActionTypes';
import {
  ClearEventData, CreateEventFailure,
  CreateEventFailurePayload,
  CreateEventRequest,
  CreateEventStarted,
  CreateEventSuccess,
  CreateEventSuccessPayload,
  PatchEventStatusRequest,
  UpdateEventFailure,
  UpdateEventRequest,
  UpdateEventSuccess
} from '../../types/events/CreateEventTypes';

export const createEventRequest = (reqObject: IEventsRequestModel): CreateEventRequest => ({
  type: createEvent.CREATE_EVENT_REQUEST,
  requestObject: reqObject
});

export const updateEventRequest = (
  reqObject: IEventsRequestModel,
  version: number
): UpdateEventRequest => ({
  type: updateEvents.UPDATE_EVENT_REQUEST,
  requestObject: reqObject,
  version
});

export const patchEventRequest = (
  reqObject: IPatchStatusModel,
  eName: string,
  version: number
): PatchEventStatusRequest => ({
  type: patchEventStatusType.PATCH_EVENT_STATUS_REQUEST,
  requestObject: reqObject,
  eventName: eName,
  version
});

/**
 * Create event started saga action
 * @returns event started action
 */
export const createEventStart = (): CreateEventStarted => ({
  type: createEventStarted.type
});

/**
 * Create event success saga action
 * @param payload :Event data
 * @returns success action
 */
export const createEventSuccessfull = (
  payload: CreateEventSuccessPayload
): CreateEventSuccess => ({
  type: createEventSuccess.type,
  payload
});

/**
 * Create Event Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const createEventFailure = (
  payload: CreateEventFailurePayload
): CreateEventFailure => ({
  type: createEventFail.type,
  payload
});

/**
 * Update event success saga action
 * @param payload :Event data
 * @returns success action
 */
export const UpdateEventSuccessfull = (
  payload: CreateEventSuccessPayload
): UpdateEventSuccess => ({
  type: updateEventSuccess.type,
  payload
});

/**
 * Update Event Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const UpdateEventFailures = (
  payload: CreateEventFailurePayload
): UpdateEventFailure => ({
  type: updateEventFail.type,
  payload
});

/**
 * Clear Events saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearEvents = (): ClearEventData => ({
  type: clearEvent.type
});
